/* eslint-disable no-console */
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('vue:error', (..._args) => {
    if (process.client) {
      console.error('vue:error', ..._args)
    }
  })
  nuxtApp.hook('app:error', (..._args) => {
    if (process.client) {
      console.error('app:error', ..._args)
    }
  })
  nuxtApp.vueApp.config.errorHandler = (..._args) => {
    if (process.client) {
      console.error('global error handler', ..._args)
    }
  }
})
